export {
  default,
} from 'web-ssr/app/services/components/ServicesSearch/Container';
